<template>
  <button
    :class="['gradient-button', size, type, { 'disabled': disabled }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'GradientButton',
  props: {
    // 按钮大小：small, medium, large
    size: {
      type: String,
      default: 'medium'
    },
    // 按钮类型：primary, success, warning, danger, info
    type: {
      type: String,
      default: 'primary'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gradient-button {
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  outline: none;
  font-weight: 500;
  border-radius: 27px;
  padding: 0 20px;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
    pointer-events: none;
  }

  // 主要按钮 - 蓝绿色渐变
  &.primary {
    background: #0090ff;
    color: white;

    &:hover {
      background: #007ad9;
    }
  }

  // 成功按钮 - 绿色渐变
  &.success {
    background: linear-gradient(90deg, #00d4a5, #52c41a);
    color: white;
  }

  // 警告按钮 - 橙色渐变
  &.warning {
    background: linear-gradient(90deg, #fa8c16, #f5222d);
    color: white;
  }

  // 危险按钮 - 红色渐变
  &.danger {
    background: linear-gradient(90deg, #f5222d, #cf1322);
    color: white;
  }

  // 信息按钮 - 紫色渐变
  &.info {
    background: linear-gradient(90deg, #722ed1, #9254de);
    color: white;
  }

  // 大小
  &.small {
    height: 36px;
    font-size: 12px;
    padding: 0 16px;
  }

  &.medium {
    height: 54px;
    font-size: 14px;
    padding: 0 20px;
  }

  &.large {
    height: 64px;
    font-size: 16px;
    padding: 0 24px;
  }

  // 插槽内容样式
  ::v-deep {
    img,
    .el-image {
      width: 20px;
      height: 20px;
      object-fit: contain;
    }

    i {
      font-size: 16px;
    }
  }
}
</style>
